import { CircularProgress } from '@material-ui/core';
import './loader.sass';

const Loader = () => (
  <div className='loader-container'>
    <CircularProgress />
  </div>);

export default Loader;